export default "__VITE_ASSET__ae818fc2__"